export var Callback;
(function (Callback) {
    Callback["NETS"] = "nets";
    Callback["VIPPS"] = "vipps";
})(Callback || (Callback = {}));
